import { ManifestPackageProps, ManifestSSCCProps } from '../../../datastore/tripSheets';
import { transportBookingFormPrefix } from '../../../common/strings';
import { variousAsn } from '../../../common/constants';

export function ssccContainsTbfPackage(sscc: ManifestSSCCProps): boolean {
  return !!sscc.packages.find((pkg) => pkg.asn.startsWith(transportBookingFormPrefix));
}

export function shouldShowDirectReceiptForTBF(pkg: ManifestPackageProps, sscc: ManifestSSCCProps): boolean {
  return pkg.asn.startsWith(transportBookingFormPrefix) && pkg === sscc.packages[0];
}

export function shouldShowDirectReceiptForNonTBF(
  pkg: ManifestPackageProps,
  isFirstPackage: boolean,
  sameAsn: boolean,
  ssccHasTbf: boolean
): boolean {
  return (
    ssccHasTbf &&
    !pkg.asn.startsWith(transportBookingFormPrefix) &&
    pkg.asn?.toUpperCase() !== variousAsn &&
    (!sameAsn || isFirstPackage)
  );
}
